import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography, Chip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SimpleTable from './charts/SimpleTable';

const Comments = ({ comments, columns = false, rows = false }) => {
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    let data = [];

    if (columns || rows) {
        //split data by (maybe) row, column and name for multiple Matrix-type questions
        data = comments?.length > 0 ? Object.values(
            comments.reduce((acc, item) => {
                const rowKey = item.row?.toString().toLowerCase();
                const columnKey = item.column?.toString().toLowerCase();
                const commentKey = item.comment?.toString().toLowerCase();

                const key = rows
                    ? `${rowKey}-${columnKey}-${commentKey}`
                    : `${columnKey}-${commentKey}`;

                if (!acc[key]) {
                    acc[key] = {
                        ...(rows && { row: item.row }),
                        column: item.column,
                        name: item.comment,
                        value: 1
                    };
                }
                else {
                    acc[key].value++;
                }

                return acc;
            }, {})
        ) : [];
    }
    else {
        data = comments?.length > 0 ? Object.values(
            comments.reduce((acc, item) => {
                const key = item.toString().toLowerCase();

                if (!acc[key]) {
                    acc[key] = {
                        name: item,
                        value: 1
                    };
                }
                else {
                    acc[key].value++;
                }

                return acc;
            }, {})
        ) : [];
    }

    const matches = comments.length - data.length;

    return (
        <Accordion expanded={expanded === 'comments'} onChange={handleChange('comments')}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="comments-content"
                id="comments-header"
            >
                <Typography component="span" variant="body1">
                    View Comments ({comments.length})
                </Typography>
                {matches > 0 && (
                    <Chip
                        size="small"
                        label={`${data.length} Unique`}
                        color="secondary"
                        sx={{
                            ml: 1
                        }}
                    />
                )}
            </AccordionSummary>
            <AccordionDetails>
                <SimpleTable
                    data={data}
                    columns={columns}
                    rows={rows}
                />
            </AccordionDetails>
        </Accordion>
    );
};

export default Comments;